import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { c as cl } from './clsx.m.js';
import { a as createLogger, u as updateElementStyle, d as isNumber, f as isUnset, n as numToRem } from './utils.js';

// Constants
const component = 'cl-scroll-wrapper';

const clScrollWrapperCss = ".sc-cl-scroll-wrapper-h{--wrapper-margin:0;--wrapper-max-width:100%;--wrapper-scrollbar-gutter:auto;--scroll-track-color:transparent;--scroll-thumb-color:transparent;--scroll-thumb-border-color:transparent;display:block;margin:var(--wrapper-margin);max-height:var(--custom-wrapper-max-height, var(--wrapper-max-height, auto));max-width:var(--wrapper-max-width);overflow:auto}.sc-cl-scroll-wrapper-h,.sc-cl-scroll-wrapper-h *.sc-cl-scroll-wrapper,.sc-cl-scroll-wrapper-h *.sc-cl-scroll-wrapper::before,.sc-cl-scroll-wrapper-h *.sc-cl-scroll-wrapper::after,.sc-cl-scroll-wrapper-h .sc-cl-scroll-wrapper-s>*,.sc-cl-scroll-wrapper-h .sc-cl-scroll-wrapper-s *,.sc-cl-scroll-wrapper-h .sc-cl-scroll-wrapper-s *::before,.sc-cl-scroll-wrapper-h .sc-cl-scroll-wrapper-s *::after{box-sizing:border-box}.scroll-wrapper.sc-cl-scroll-wrapper-h{scrollbar-color:var(--scroll-track-color) var(--scroll-thumb-color);scrollbar-gutter:var(--wrapper-scrollbar-gutter, auto);scrollbar-width:auto}.scroll-wrapper--small.sc-cl-scroll-wrapper-h{scrollbar-width:thin}.scroll-wrapper.sc-cl-scroll-wrapper-h::-webkit-scrollbar{height:var(--spacing-1);width:var(--spacing-1)}.scroll-wrapper.sc-cl-scroll-wrapper-h::-webkit-scrollbar-corner{background-color:transparent}.scroll-wrapper--small.sc-cl-scroll-wrapper-h:not(.scroll-wrapper--show-track)::-webkit-scrollbar{height:var(--spacing-half);width:var(--spacing-half)}.scroll-wrapper--small.sc-cl-scroll-wrapper-h:not(.scroll-wrapper--show-track)::-webkit-scrollbar-track{height:var(--spacing-half);width:var(--spacing-half)}.scroll-wrapper--small.sc-cl-scroll-wrapper-h:not(.scroll-wrapper--show-track)::-webkit-scrollbar-thumb{border-width:0;width:var(--spacing-half)}.scroll-wrapper.sc-cl-scroll-wrapper-h::-webkit-scrollbar-track{background-color:var(--scroll-track-color);border-radius:var(--border-radius-interactive-large);height:var(--spacing-1);width:var(--spacing-1)}.scroll-wrapper.sc-cl-scroll-wrapper-h::-webkit-scrollbar-thumb{background-color:var(--scroll-thumb-color);border-color:var(--scroll-thumb-border-color);border-radius:var(--border-radius-interactive-large);border-style:solid;border-width:var(--spacing-quarter);width:var(--spacing-1)}.scroll-wrapper.sc-cl-scroll-wrapper-h:hover{--scroll-track-color:transparent;--scroll-thumb-color:rgba(var(--color-neutral-200));--scroll-thumb-border-color:rgba(var(--color-neutral-200))}.scroll-wrapper.sc-cl-scroll-wrapper-h:hover.scroll-wrapper--small{--scroll-thumb-border-color:rgba(var(--color-neutral-100))}.scroll-wrapper.sc-cl-scroll-wrapper-h:hover.scroll-wrapper--small.scroll-wrapper--show-track{--scroll-thumb-border-color:rgba(var(--color-neutral-100))}.scroll-wrapper.sc-cl-scroll-wrapper-h:hover.scroll-wrapper--show-track{--scroll-track-color:rgba(var(--color-neutral-100))}.scroll-wrapper.sc-cl-scroll-wrapper-h::-webkit-scrollbar-track:hover{--scroll-track-color:rgba(var(--color-neutral-100))}.scroll-wrapper--persistent.sc-cl-scroll-wrapper-h{--scroll-thumb-color:rgba(var(--color-neutral-200));--scroll-thumb-border-color:rgba(var(--color-neutral-200))}.scroll-wrapper--persistent.scroll-wrapper--small.sc-cl-scroll-wrapper-h{--scroll-thumb-border-color:rgba(var(--color-neutral-100))}.scroll-wrapper--persistent.scroll-wrapper--show-track.sc-cl-scroll-wrapper-h{--scroll-track-color:rgba(var(--color-neutral-100))}";

const ClScrollWrapper = /*@__PURE__*/ proxyCustomElement(class ClScrollWrapper extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    /**
     * Object containing custom consoleLogger functions.
     */
    this.logger = createLogger(component);
    this.maxHeight = undefined;
    this.persistent = false;
    this.thumbOnly = false;
    this.small = false;
  }
  /**
   * Validates the maxHeight property and updates the styles accordingly
   */
  handleMaxHeight(maxHeight) {
    const cssVariable = '--custom-wrapper-max-height';
    switch (true) {
      case isUnset(maxHeight):
        updateElementStyle(this.element, undefined, cssVariable);
        break;
      case !isNumber(maxHeight):
        this.logger.error.attribute.maxHeight(`Given invalid value "${maxHeight}".`);
        break;
      default:
        updateElementStyle(this.element, numToRem(maxHeight), cssVariable);
        break;
    }
  }
  /**
   * Every time the component is connected to the DOM:
   * - Validate the maxHeight attribute and update the styles;
   */
  connectedCallback() {
    this.handleMaxHeight(this.maxHeight);
  }
  render() {
    const { persistent, small, thumbOnly } = this;
    return (h(Host, { class: cl('scroll-wrapper', {
        'scroll-wrapper--small': small,
        'scroll-wrapper--show-track': !thumbOnly,
        'scroll-wrapper--persistent': persistent,
      }) }, h("div", null, h("slot", null))));
  }
  get element() { return this; }
  static get watchers() { return {
    "maxHeight": ["handleMaxHeight"]
  }; }
  static get style() { return clScrollWrapperCss; }
}, [6, "cl-scroll-wrapper", {
    "maxHeight": [2, "max-height"],
    "persistent": [4],
    "thumbOnly": [4, "thumb-only"],
    "small": [4]
  }]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["cl-scroll-wrapper"];
  components.forEach(tagName => { switch (tagName) {
    case "cl-scroll-wrapper":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ClScrollWrapper);
      }
      break;
  } });
}

export { ClScrollWrapper as C, defineCustomElement as d };

//# sourceMappingURL=cl-scroll-wrapper2.js.map